import { Radikle } from '../Components/Radikle.jsx';
import axios from "axios"

import { useNavigate } from "react-router-dom";

import { useState, useEffect } from 'react';

import { Modal } from '../Components/Modal.jsx';

import { OAUTH_URI, API_URI } from '../config/constants.js';

import { useUser } from "../Contexts/UserContext.jsx";

import { useLoading } from "../Contexts/LoadingContext";

export function Scopes() {
  const navigate = useNavigate();
  const { setLoading } = useLoading();

  const [infoModal, setInfoModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const onModalClose = () => {
  
  }

  const { scopes, userSessionId, emailAddress} = useUser();

    const selectedScopes = Object.keys(scopes).join(" ");

  function navigateLogin() {
    navigate('/login');
  }

  async function submitScopeSelection() {
    setLoading(true);
    await axios.post(API_URI + "/user/scopes", {selectedScopes, userSessionId, emailAddress}, { withCredentials: true })
      .then((response) => {
        setLoading(false);
        handleResponse(response);
      }).catch((error) => {
        setLoading(false);
        handleError(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  function handleError(error) {
    console.log("ERROR: upon calling scopes endpoint" + error.message);
    navigate("/error");
  }

  function handleResponse(response) {
    console.log("INFO: Response received for scopes endpoint ");
    if(response == null || response.data == null) {
      return;
    }
    if(response.data.responseCode === 2220) {
      let authorizationCode = response.data.responseData.AuthorizationCode;
      // This is the final call to redirect successful login. 
      // There could be scope selection page after successful login and before redirection.
      // Hence this explicit step is included.
      authorizedUser(authorizationCode);
    }
    if(response.data.responseCode === 2230) {
      let authorizationRedirection = response.data.responseData.AuthorizationRedirection;
      window.location.href = authorizationRedirection;    
    }
  }

  async function authorizedUser(authorizationCode) {
    setLoading(true);
    let authorizedUrl = OAUTH_URI + "/authorized";
    await axios.post(authorizedUrl, {userSessionId, authorizationCode}, { withCredentials: true })
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
        }
        console.log("INFO: Response received for authorized endpoint ");
        handleResponse(response);
      }).catch((error) => {
        setLoading(false);
        console.log("ERROR: upon calling authorized endpoint" + error.message);
        handleError(error);
        displayModalMessage(error);
      }).finally(() => {
        setLoading(false);
      });
  }

  function displayModalMessage(mssg) {
    setModalMessage(mssg);
    setInfoModal(true);
  }

  useEffect(() => {
    }, [] // Empty Dependency Array - 
          // Executed only once when the page launches but not on every re-render
  );  

  return (
    <>
    <div>
      <div className="TableContainer">
        <div className="Table">
          <div className="TableBody">
            <div className="TableRow">
              <label className="Email-label">Requested Scopes (selected by default)</label>
            </div>
            {Object.entries(scopes).map(([scope, description]) => (
              <div key={scope} className="TableRow">
                <input className="Email-field" type="text" autoComplete="off" value={description} readOnly/>
              </div>
            ))}
            <div className="TableRow">
              <button id="reset-button" className="Reset-button" onClick={submitScopeSelection}><span>Approve</span></button>
            </div>          
            <div className="TableRow">
              <button id="reset-button" className="Reset-button" onClick={navigateLogin}><span>Reject</span></button>
            </div>                      
          </div>
        </div>
      </div>
    </div>
    <Modal message={modalMessage} show={infoModal} setInfoModal={setInfoModal} onModalClose={onModalClose}></Modal>
    </>
  )
}
